import React from 'react';
import "./Header.scss"

const Header = () => {
  return (
    <h1>Popular Tour Places</h1>
  )
}

export default Header